module.exports = __webpack_public_path__ + "static/media/awards_preview.000f5c77.png";